// Auto-generated from Foundry artifacts — DO NOT EDIT
// Source: packages/vault/contracts/out/FeeModule.sol/FeeModule.json

export const FEE_MODULE_ABI = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "MAX_MANAGEMENT_FEE_BPS",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint16",
        internalType: "uint16",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "MAX_PERFORMANCE_FEE_BPS",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint16",
        internalType: "uint16",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "authorizedFactory",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "computeEffectiveFee",
    inputs: [
      {
        name: "baseFee",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "depositorTier",
        type: "uint8",
        internalType: "enum Tier",
      },
      {
        name: "isManagement",
        type: "bool",
        internalType: "bool",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint16",
        internalType: "uint16",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "getAccruedFees",
    inputs: [
      {
        name: "vault",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "management",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "performance",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getFeeRates",
    inputs: [
      {
        name: "vault",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "mgmt",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "perf",
        type: "uint16",
        internalType: "uint16",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getFeeRecipient",
    inputs: [
      {
        name: "vault",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getHighWaterMark",
    inputs: [
      {
        name: "vault",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "initializeVaultFees",
    inputs: [
      {
        name: "vault",
        type: "address",
        internalType: "address",
      },
      {
        name: "managementFeeBps",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "performanceFeeBps",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "feeRecipient",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "report",
    inputs: [
      {
        name: "vault",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "managementFee",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "performanceFee",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setAuthorizedFactory",
    inputs: [
      {
        name: "factory",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "vaultFees",
    inputs: [
      {
        name: "vault",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "managementFeeBps",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "performanceFeeBps",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "feeRecipient",
        type: "address",
        internalType: "address",
      },
      {
        name: "highWaterMark",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "lastReportTimestamp",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "accruedManagementFees",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "accruedPerformanceFees",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "event",
    name: "FeesReported",
    inputs: [
      {
        name: "vault",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "managementFee",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "performanceFee",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "hwm",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "VaultFeesInitialized",
    inputs: [
      {
        name: "vault",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "mgmtBps",
        type: "uint16",
        indexed: false,
        internalType: "uint16",
      },
      {
        name: "perfBps",
        type: "uint16",
        indexed: false,
        internalType: "uint16",
      },
      {
        name: "recipient",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "AlreadyInitialized",
    inputs: [],
  },
  {
    type: "error",
    name: "FactoryAlreadySet",
    inputs: [],
  },
  {
    type: "error",
    name: "ManagementFeeTooHigh",
    inputs: [],
  },
  {
    type: "error",
    name: "NotAuthorizedFactory",
    inputs: [],
  },
  {
    type: "error",
    name: "NotInitialized",
    inputs: [],
  },
  {
    type: "error",
    name: "OnlyVault",
    inputs: [],
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "PerformanceFeeTooHigh",
    inputs: [],
  },
  {
    type: "error",
    name: "ZeroAddress",
    inputs: [],
  },
] as const;

export const FEE_MODULE_BYTECODE =
  "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";
